import { TrackItem } from "../Types";

export default function TrackView(props: { track: TrackItem }) {
    return (
        <div className="Flex Column" style={{ width: "100%" }} >
            <h2>{props.track.title}</h2>
            <audio controls style={{ width: "100%" }}>
                <source src={props.track.url} type="audio/mpeg" />
                Your browser does not support the audio element.
            </audio>
        </div>
    );
}
